import { styled, css } from 'styled-components';

export const Container = styled.button<{ $view: CalendarView }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $view }) => css`
    all: unset;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    box-shadow: none;
    cursor: pointer;
    margin: 0;
    opacity: 1;
    pointer-events: auto;
    transition: none;
    visibility: visible;

    p {
      color: ${colors.brandPrimary};
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      line-height: 1rem;
      margin: 0;
      user-select: none;
    }

    ${
      $view === 'weekly' &&
      css`
        align-items: center;
        border: 1px dashed transparent;
        border-radius: 0.25rem;
        box-sizing: border-box;
        display: flex;
        gap: 0.25rem;
        height: 4.875rem;
        justify-content: center;
        min-height: 4.875rem;
        padding: 0;
        width: 100%;
      `
    }

    @media Print {
      display: none;
    }
  `}
`;
